import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useCustomer } from "@/lib/customer";

export default function CustomerAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setCustomer } = useCustomer();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    api
      .post("/customer/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setCustomer(data);
        window.history.replaceState(null, "", location.pathname);
        if (data.linked_orders) toast.success(`${data.linked_orders} commande(s) passée(s) rattachée(s) à votre compte`);
        navigate("/compte", { replace: true, state: { customer: data } });
      })
      .catch((err) => {
        setError(formatApiError(err));
        window.history.replaceState(null, "", location.pathname);
      });
  }, [location, navigate, setCustomer]);

  if (error) {
    return (
      <div data-testid="customer-callback-error" className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 text-center">
        <p className="font-serif text-2xl text-teal-dark">Connexion Google impossible</p>
        <p className="text-sm text-ink/70">{error}</p>
        <button onClick={() => navigate("/compte/connexion", { replace: true })} className="rounded-full bg-teal px-8 py-3 text-cream text-sm">Retour à la connexion</button>
      </div>
    );
  }
  return (
    <div data-testid="customer-callback-loading" className="min-h-screen flex items-center justify-center">
      <Loader2 size={32} className="animate-spin text-teal" />
    </div>
  );
}
